/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb1_CtaInputs */

const en_visa_eb1_cta = /** @type {(inputs: Visa_Eb1_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discuss your EB-1 eligibility`)
};

const pt_visa_eb1_cta = /** @type {(inputs: Visa_Eb1_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discuta sua elegibilidade EB-1`)
};

const es_visa_eb1_cta = /** @type {(inputs: Visa_Eb1_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hable sobre su elegibilidad EB-1`)
};

/**
* | output |
* | --- |
* | "Discuss your EB-1 eligibility" |
*
* @param {Visa_Eb1_CtaInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb1_cta = /** @type {((inputs?: Visa_Eb1_CtaInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb1_CtaInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb1_cta(inputs)
	if (locale === "es") return es_visa_eb1_cta(inputs)
	return en_visa_eb1_cta(inputs)
});